import React from 'react';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';
import { Accordion } from '../common-components/accordion';

type ProvisionsProps = {
  provisions: string[];
};

export const Provisions = React.memo(({ provisions }: ProvisionsProps) => {
  if (!provisions || provisions.length === 0) {
    return null; // Return null if there are no provisions to display
  }

  return (
    <Accordion accordionId='provisions' accordionTitle='Provisions'>
      <ul css={{ padding: 'inherit', paddingLeft: theme.spacing(2), paddingTop: theme.spacing(1) }}>
        {provisions.map((value, index) => {
          return (
            <Text as='li' key={(value || '') + index}>
              {value}
            </Text>
          );
        })}
      </ul>
    </Accordion>
  );
});

Provisions.displayName = 'Provisions';
